import {Pay} from '@gongxigames/framework/slotV2/types/LogicData';

export type WinMeterFinishedValue = {
    win: number;
    totalWin: number;
    isBigWin: boolean;
};

export type StrictWinPresentationEvents = {
    'General.WinPresentation.WIN_METER_FINISHED': WinMeterFinishedValue;
    'General.WinPresentation.WIN_METER_STOPPED': void;
    'General.WinPresentation.PAYS_ANIMATION_STOPPED': void;
    'General.WinPresentation.PLAY_ALL_WIN_SYMBOLS': void;
    'General.WinPresentation.PLAY_ALL_WIN_SYMBOLS_IN_FS': void;
    'General.WinPresentation.PAY_ANIMATION_STARTED': Pay;
    'General.WinPresentation.STOP_ALL': void;
    'General.WinPresentation.PLAY_PAYS_TOGGLE': void;
    'General.WinPresentation.PLAY_PICK_WIN': number;
    'General.WinPresentation.PLAY_RESTORE_PAYS_TOGGLE': void;

    'EmitToAct.WinPresentation.PAY_ANIMATION_STARTED': Pay;
};
